import { FileDownloadOutlined, PrintOutlined } from '@mui/icons-material';
import styles from './ReportActionButtons.module.css';

export interface ReportActionButtonsProps {
	onPrint: () => void;
	onDownload: () => void;
	disabled?: boolean;
}

export const ReportActionButtons = ({ onPrint, onDownload, disabled }: ReportActionButtonsProps) => (
	<div className={styles.actions}>
		<button type="button" className={styles.printButton} onClick={onPrint} disabled={disabled}>
			<PrintOutlined className={styles.actionIcon} />
			Imprimir
		</button>
		<button type="button" className={styles.downloadButton} onClick={onDownload} disabled={disabled}>
			<FileDownloadOutlined className={styles.actionIcon} />
			Baixar PDF
		</button>
	</div>
);
